import { useTranslation } from 'react-i18next'

import { preventDefault } from '../../../../../utils/events'
import { Divider } from '../../../../Divider'
import { Switch } from '../../../../Switch'

import * as styles from './EmailRecipientsSelectDropdownHeader.module.css'

function EmailRecipientsSelectDropdownHeader({
  autoAddEnabled,
  disabled,
  onChangeAutoAdd,
}) {
  const { t } = useTranslation()

  return (
    <>
      <div
        className={styles.EmailRecipientsSelectDropdownHeader}
        onMouseDown={preventDefault}
      >
        <Switch
          disabled={disabled}
          label={t('Email.RecipientsSelectAutoAddAdditionalContactsKey')}
          value={!!autoAddEnabled}
          onChange={onChangeAutoAdd}
        />
      </div>
      <Divider />
    </>
  )
}

export default EmailRecipientsSelectDropdownHeader
